import { render } from "./CSpellView.vue?vue&type=template&id=550934e4&scoped=true"
import script from "./CSpellView.vue?vue&type=script&lang=js"
export * from "./CSpellView.vue?vue&type=script&lang=js"

import "./CSpellView.vue?vue&type=style&index=0&id=550934e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550934e4"]])

export default __exports__